import React from "react";
import {
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import "./Intents.scss";
import Authorize from '../../authComponents/authComponents';
import { freezeVersion, setSelectedVersions } from "../../redux/versions.reducer";
import { connect } from 'react-redux';

const apiCalls = require("../../ApiCalls");

class IntentSelector extends React.Component {
  constructor(props) {
    super(props);

    this.componentDidAuth = this.componentDidAuth.bind(this);
    this.getVersions = this.getVersions.bind(this);
    this.getTrainingDataVersionsList = this.getTrainingDataVersionsList.bind(this);
    this.getTrainingDataVersions = this.getTrainingDataVersions.bind(this);
    this.handleSelectTrainingDataVersion = this.handleSelectTrainingDataVersion.bind(this);
    this.state = { trainingDataVersions: [], selectedTrainingDataId: -1 };
  }

  componentDidAuth() {
    this.getVersions()
  }

  async getTrainingDataVersions() {
    return Promise.all([
      apiCalls.getTrainingDataVersions(),
      apiCalls.getSelectedVersions(),
    ])
    .then(([trainingDataVersions, selectedVersions]) => {
      let selectedTrainingDataId = -1;

      if (trainingDataVersions.versions && trainingDataVersions.versions.length > 0) {
        selectedTrainingDataId = trainingDataVersions.versions[0].id;
      }

      if (selectedVersions.selectedVersions) {
        selectedTrainingDataId = selectedVersions.selectedVersions.training_data_version_id ||
          selectedTrainingDataId;
      }

      if (trainingDataVersions.versions && selectedTrainingDataId > -1) {
        let selectedTrainingDataVersion = trainingDataVersions.versions.find(version => version.id === selectedTrainingDataId),
            freeze = selectedTrainingDataVersion ? selectedTrainingDataVersion.freeze : null;
        this.props.freezeTrainingData(freeze);
      }

      this.props.setSelectedTrainingDataVersion({ training_data_version_id: selectedTrainingDataId });

      return {
        trainingDataVersions: trainingDataVersions.versions,
        selectedTrainingDataId: selectedTrainingDataId
      };
    })
    .catch(err => { throw err; });
  }

  async getVersions() {
    let trainingDataVersions = await this.getTrainingDataVersions()
      .catch(err => console.log(err));

    if (trainingDataVersions) {
      this.setState({
        trainingDataVersions: trainingDataVersions.trainingDataVersions,
        selectedTrainingDataId: trainingDataVersions.selectedTrainingDataId
      }, () => { this.getIntents() })
    }
  }

  getTrainingDataVersionsList() {
    if (this.state.trainingDataVersions && this.state.trainingDataVersions.length > 0) {
      return this.state.trainingDataVersions.map((version, index) => {
        return (
          <option key={index} value={version.id}>{version.name}</option>
        )
      });
    }
  }

  getIntents() {
    let version = this.state.trainingDataVersions.find((version) => version.id === this.state.selectedTrainingDataId);
    let name = version ? version.name : "";

    if (version) sessionStorage.setItem("selectedTrainingDataVersion", JSON.stringify(version))
    apiCalls.getVersionIntents(this.state.selectedTrainingDataId)
      .then((result) => { this.props.handler && this.props.handler(result.intents, name) })
      .catch((err) => { this.props.handleAPIError(err) })
  }

  handleSelectTrainingDataVersion(e) {
    const VALUE = parseInt(e.target.value);
    apiCalls.setSelectedTrainingDataVersion(VALUE > 0 ? VALUE : null)
    .then(result => {
      if (result && result.success) {
        this.setState({ selectedTrainingDataId: VALUE }, () => {
          this.getVersions();
          this.getIntents();
        })
      }
    })
    .catch(err => {
      this.props.handleAPIError(err)
    });
  }

  render() {
    return <Authorize path='/intents&entities' onAuth={this.componentDidAuth}>
      <Col>
        <InputGroup className="intent-selector">
          <InputGroupAddon addonType="prepend">
            <InputGroupText className={`${this.props.className}`}>
              {this.props.text || "Intent"}
            </InputGroupText>
          </InputGroupAddon>
          <Input type="select"
                 key={"trainingPhraseId:" + this.state.selectedTrainingDataId}
                 name="training_data_version_id"
                 onChange={this.handleSelectTrainingDataVersion}
                 value={this.state.selectedTrainingDataId}>
            <option hidden={true} value={-2}></option>
            { this.getTrainingDataVersionsList() }
          </Input>
        </InputGroup>
      </Col>
    </Authorize>
  }
}

const mapStateToProps = () => { return {} }
const mapDispatchToProps = {
  setSelectedTrainingDataVersion: setSelectedVersions,
  freezeTrainingData: freezeVersion
}

export default connect(mapStateToProps, mapDispatchToProps)(IntentSelector);
